import styles from "./Answer.module.css";
import { AnswerMode } from "../../answer-modes/AnswerModeContainer/AnswerMode";
import iconMapping from "../../answer-modes/AnswerModeContainer/iconMapping";
import mbenergy_logo from "../../../../public/favicon.png";

interface AnswerModeIconProps {
  answerMode: AnswerMode;
  isLoading?: boolean; // <--- NEW PROP
}

const AnswerModeIcon: React.FC<AnswerModeIconProps> = ({
  answerMode,
  isLoading = false,
}) => {
  // Helper: The Logo optionally wrapped in a spinner
  const renderLogo = () => (
    <div className={styles.logoWrapper}>
      {isLoading && <div className={styles.spinningRing} />}
      <img
        src={mbenergy_logo}
        alt="Answer logo"
        className={styles.companyLogo}
        aria-hidden="true"
      />
    </div>
  );

  const IconComponent = iconMapping?.[answerMode.icon];

  // Standard mode: just logo (spinning or not)
  if (answerMode.mode === "standard") {
    return <span className={styles.answerModeWrapper}>{renderLogo()}</span>;
  }

  // Custom mode: Logo (spinning or not) + Badge
  return (
    <span className={styles.answerModeWrapper}>
      {renderLogo()}
      <span
        className={styles.answerModeBadge}
        style={{ backgroundColor: answerMode.color }}
      >
        {IconComponent && (
          <span className={styles.answerModeBadgeIcon}>
            <IconComponent />
          </span>
        )}
        <span className={styles.answerModeBadgeLabel}>{answerMode.name}</span>
      </span>
    </span>
  );
};

export default AnswerModeIcon;
